import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=bc192aa0"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=bc192aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports